/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

const ErrorImage = () => {
	return (
		<svg
			fill="none"
			viewBox=".02 0 234.96 210.11"
			xmlns="http://www.w3.org/2000/svg"
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			style={{ width: '230px' }}
		>
			<g clipPath="url(#c)">
				<rect
					transform="translate(.024902)"
					width="234.95"
					height="210.11"
					fill="#fff"
					fillOpacity=".01"
				/>
				<path
					d="m179.68 165.78v-13.28h23.37v-13.29h26.21v-13.29h-26.21v-87.18h-38.73v-38.74h-123.72v44.85h28.74v13.29h-65.16v13.29h22.32v13.29h32.67v13.28h-59.14v13.29h40.57v98.82h162.45v-17.75h-48.22v-13.29h80.16v-13.29h-55.31zm-60.81-108.43c6.29 0 11.31 5.27 11 11.55l-2.53 51.01c-0.22 4.51-3.95 8.06-8.47 8.06s-8.24-3.54-8.47-8.06l-2.53-51.01c-0.31-6.28 4.7-11.55 11-11.55zm0 98.33c-5.72 0-10.36-4.64-10.36-10.36s4.64-10.36 10.36-10.36 10.36 4.64 10.36 10.36-4.64 10.36-10.36 10.36z"
					fill="url(#b)"
				/>
				<path d="m164.58 59.32 38.2-20.58h-38.2v20.58z" fill="url(#a)" opacity=".6" />
				<path d="m203.04 38.71h-0.03l0.03 0.03v-0.03z" fill="#E7E8EC" />
				<path d="m164.58 59.32 38.2-20.58h-38.2v20.58z" fill="url(#a)" opacity=".6" />
				<path d="m164.58 38.74h38.47l-38.74-38.74v38.74h0.27z" fill="#EBECF0" opacity=".2" />
			</g>
			<defs>
				<linearGradient
					id="b"
					x1="28.905"
					x2="195.81"
					y1="198.42"
					y2="31.511"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#C1C7D0" offset=".0977" />
					<stop stopColor="#EBECF0" stopOpacity=".5" offset="1" />
				</linearGradient>
				<linearGradient
					id="a"
					x1="163.84"
					x2="204.24"
					y1="58.581"
					y2="18.173"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#A5ADBA" stopOpacity="0" offset="0" />
					<stop stopColor="#A5ADBA" offset="1" />
				</linearGradient>
				<clipPath id="c">
					<rect transform="translate(.024902)" width="234.95" height="210.11" fill="#fff" />
				</clipPath>
			</defs>
		</svg>
	);
};

export { ErrorImage };
